<template>
  <form method="post" @submit.prevent="send" novalidate>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title is-centered">轉團</p>
      </header>
      <section class="modal-card-body">
        <form-wrapper :validator="$v.form">
          <template #label>
            {{ $t('attributes.collaborate_group') }}
            <!-- eslint-disable-next-line-->
                <span v-if="selectedGroupName" v-html="': ' + selectedGroupName"></span>
          </template>
          <form-group name="order_no" label="訂單" horizontal expanded>
            <b-input
              :value="`[${order.order_no}] ${order.user_name}`"
              disabled
            />
          </form-group>
          <form-group name="from_group" label="從" horizontal expanded>
            <b-input
              :value="`${order.group_code} - ${order.group_name}`"
              disabled
            />
          </form-group>
          <form-group name="group_code" label="轉到" horizontal expanded>
            <b-autocomplete
              ref="group_code_input"
              v-model="group_code"
              name="group_code"
              field="code"
              :custom-formatter="group => `${group.code} - ${group.name}`"
              :data="groups"
              :loading="isLoadingGroups"
              :placeholder="$t('message.please_input_group_code')"
              :open-on-focus="false"
              @typing="loadGroups"
              @select="onSelectGroup"
            >
              <template #default="props">
                <p>
                  {{ props.option.code }} -
                  <!-- eslint-disable-next-line-->
                  <span v-html="props.option.name" />
                </p>
              </template>
              <template #empty>
                {{
                  group_code
                    ? isLoadingGroups
                      ? $t('attributes.searching')
                      : $t('attributes.not_found')
                    : $t('message.please_input_group_code')
                }}
              </template>
            </b-autocomplete>
          </form-group>
        </form-wrapper>
      </section>

      <footer class="modal-card-foot">
        <b-button :loading="isSending" @click="$parent.close()">
          {{ $t('attributes.cancel') }}
        </b-button>
        <b-button
          :loading="isSending || isLoading"
          type="is-primary"
          native-type="submit"
        >
          {{ $t('attributes.transfer') }}
        </b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import debounce from 'lodash/debounce'
import { required } from 'vuelidate/lib/validators'
import { TRAVEL_GROUPS_API, COLLABORATE_ORDERS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'OrderTransferForm',

  props: {
    order: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isLoadingGroups: false,
      groups: [],
      selectedGroupName: null,

      isSending: false,
      group_code: null,
      form: {
        order_no: this.order.order_no,
        group_code: null
      }
    }
  },
  validations: {
    form: {
      order_no: { required },
      group_code: { required }
    }
  },
  computed: {
    isLoading() {
      return this.isLoadingGroups
    }
  },
  mounted() {
    this.$refs.group_code_input.focus()
  },
  methods: {
    async loadAsyncGroups() {
      const api = `${TRAVEL_GROUPS_API}/search/collaborate`
      const params = {
        code: this.group_code
      }

      this.isLoadingGroups = true
      try {
        const res = await this.axios.get(api, { params })
        this.groups = res.data.data.filter(
          g =>
            g.code !== this.order.group_code &&
            g.activity_id === this.order.user_activity.activity_id
        )
      } catch (e) {
        this.groups = []

        notifyService.fetch_error('collaborate_group', e)
      } finally {
        this.isLoadingGroups = false
      }
    },
    loadGroups: debounce(function() {
      if (!this.group_code) {
        this.groups = []
        return
      }

      this.loadAsyncGroups()
    }, 1000),
    onSelectGroup(option) {
      this.form.group_code = option && option.code
      this.selectedGroupName = option && option.name
    },
    async send() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      await this.transfer(this.form)
    },
    async transfer(data) {
      const api = `${COLLABORATE_ORDERS_API}/transfer`

      this.isSending = true
      try {
        await this.axios.post(api, data)
        notifyService.success('轉團成功')
        this.$emit('onComplete')
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
        notifyService.error('轉團失敗')
      } finally {
        this.isSending = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-card {
  min-height: 480px;
}
</style>
